import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Testimonials from '../home/testimonials.js';
import { ReactComponent as IconDropdown } from '../../media/icons/dropdown.svg';

export default class BenefitsAgencies extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            background_url: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/hero/hero.webp",
            question_expanded: false,
            questions_content: [
                {
                    question: 'Why should a tourism board publish itineraries on Guidr?',
                    answer:
                        'Beautiful, ready-made trips inspire visitors, encourage longer stays, and distribute foot traffic beyond the “top three” sights - supporting local businesses across your whole region.'
                },
                {
                    question: 'Does it cost anything for DMOs or CVBs?',
                    answer:
                        'No. Creating, hosting, and sharing itineraries on Guidr is completely free. Your only investment is a bit of time and regional know-how.'
                },
                {
                    question: 'How many itineraries can we publish?',
                    answer:
                        'As many as you like - create one-day highlights, themed week-long routes, or seasonal experiences. Unlimited drafts and updates.'
                },
                {
                    question: 'Can we feature partner businesses in the content?',
                    answer:
                        'Absolutely. Highlight hotels, restaurants, attractions, and tours; include affiliate links or booking widgets to drive direct revenue to local partners.'
                },
                {
                    question: 'How do we distribute these itineraries?',
                    answer:
                        'Embed them on your official website, print QR codes for visitor centers, share direct links in social media campaigns, or provide them to local accommodations to include in pre-arrival emails.'
                },
                {
                    question: 'Is there multilingual support?',
                    answer:
                        'Not yet. We are currently available in English language only. But we are improving Guidr every day and will soon also offer multilingual itineraries.'
                },
                {
                    question: 'Who owns the content we upload?',
                    answer:
                        'You retain full ownership. Guidr only hosts and displays the itineraries; you can edit or remove them anytime.'
                },
                {
                    question: 'Can we collaborate with influencers or local experts?',
                    answer:
                        'Definitely! Invite creators to co-author itineraries, add their insider tips, and then cross-promote through their channels.'
                },
                {
                    question: 'Do travelers need an account to view itineraries?',
                    answer:
                        'No. They can open public itineraries instantly - no paywall or signup. (You can still opt to gate premium versions if you wish.)'
                }
            ]
        };

        this.toggleQuestion = this.toggleQuestion.bind(this);
    }

    toggleQuestion(index) {
        this.setState({
            question_expanded:
                index === this.state.question_expanded ? false : index
        });
    }

    render() {
        return (
            <div className="content-container">

                <Helmet>
                    {/* Add the breadcrumb schema as JSON-LD */}
                    <script type="application/ld+json">
                        {`
                            {
                                "@context": "https://schema.org",
                                "@type": "BreadcrumbList",
                                "itemListElement": [
                                {
                                    "@type": "ListItem",
                                    "position": 1,
                                    "name": "Guidr Home",
                                    "item": "https://guidr.net/"
                                },
                                {
                                    "@type": "ListItem",
                                    "position": 2,
                                    "name": "Guidr for tourism agencies",
                                    "item": "https://guidr.net/tourismagencies"
                                }
                                ]
                            }
                                    `}
                    </script>
                    <title>{"Attract more guests with tailored itineraries | Guidr"}</title>
                </Helmet>

                {/* ========== HERO ========== */}
                <div className="content-container hero-container">
                    <div className="hero__background">
                        <img
                            src={this.state.background_url}
                            alt=""
                            className="hero__background-inner"
                        />
                    </div>
                    <div className="hero__background hero__background--overlay"></div>

                    <div className="content-wrapper--wide persona__hero-wrapper">
                        <div></div>
                        <div className="persona__hero__title-container">
                            <h1 className="persona__hero__title__element text-title text-color-light">
                                Inspire travelers to explore&nbsp;your region
                            </h1>
                            <div className="persona__hero__title__element text-color-light">
                                Publish free, shareable itineraries that boost
                                visitation and local spend
                            </div>
                            <Link
                                to="/signup"
                                className="persona__hero__title__button button button-large button-primary-light"
                            >
                                Promote your region
                            </Link>
                        </div>
                    </div>
                </div>

                {/* ========== 3-STEP EXPLAINER ========== */}
                <div className="content-wrapper">
                    <div className="persona__explainer-container">
                        {/* STEP 1 */}
                        <div className="persona__explainer__element__circle">
                            <div className="persona__explainer__element__circle-inner">
                                1
                            </div>
                        </div>
                        <div className="persona__explainer__element__content">
                            <div className="persona__explainer__element__content__summary">
                                <div className="persona__explainer__element__content__summary_title text-subtitle text-bold">
                                    Craft compelling itineraries
                                </div>
                                <div className="persona__explainer__element__content__summary__video">
                                    <img src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/personas/creators_1.webp"} className="persona__explainer__element__content__summary__video-inner" />
                                </div>
                            </div>
                            <div className="persona__explainer__element__content__details">
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">🌄 Showcase seasonal highlights</span>  -  festivals,
                                    nature trails, and cultural gems.
                                </p>
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">🤝 Partner with local businesses</span> to feature
                                    tours, dining, and unique stays.
                                </p>
                            </div>
                        </div>

                        {/* STEP 2 */}
                        <div className="persona__explainer__element__circle">
                            <div className="persona__explainer__element__circle-inner">
                                2
                            </div>
                        </div>
                        <div className="persona__explainer__element__content">
                            <div className="persona__explainer__element__content__summary">
                                <div className="persona__explainer__element__content__summary_title text-subtitle text-bold">
                                    Distribute everywhere
                                </div>
                                <div className="persona__explainer__element__content__summary__video">
                                    <img src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/personas/creators_2.webp"} className="persona__explainer__element__content__summary__video-inner" />
                                </div>
                            </div>
                            <div className="persona__explainer__element__content__details">
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">📲 Share via website & QR codes</span> in visitor
                                    centers, welcome packs, and ad campaigns.
                                </p>
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">🔗 Drive traffic to Guidr pages</span> for maps and
                                    real-time updates.
                                </p>
                            </div>
                        </div>

                        {/* STEP 3 */}
                        <div className="persona__explainer__element__circle">
                            <div className="persona__explainer__element__circle-inner">
                                3
                            </div>
                        </div>
                        <div className="persona__explainer__element__content">
                            <div className="persona__explainer__element__content__summary">
                                <div className="persona__explainer__element__content__summary_title text-subtitle text-bold">
                                    Grow visitation & spend
                                </div>
                                <div className="persona__explainer__element__content__summary__video">
                                    <img src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/personas/creators_3.webp"} className="persona__explainer__element__content__summary__video-inner" />
                                </div>
                            </div>
                            <div className="persona__explainer__element__content__details">
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">📈 Boost overnight stays</span> by encouraging
                                    multi-day routes and off-peak travel.
                                </p>
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">🗂️ Measure impact & refine</span> with detailed
                                    engagement analytics.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content-wrapper">
                    <Testimonials
                        data={this.props.testimonials}
                    />
                </div>

                {/* ========== FAQ ========== */}
                <div className="content-wrapper">
                    <div className="persona__faq-container">
                        <h2 className="persona__faq__title text-title">
                            Frequently asked questions (FAQ)
                        </h2>

                        <div className="persona__faq-wrapper">
                            {this.state.questions_content.map((element, i) => (
                                <div
                                    key={i}
                                    className={
                                        'persona__faq__element' +
                                        (this.state.question_expanded === i
                                            ? ' persona__faq__element--expanded'
                                            : '')
                                    }
                                >
                                    <div
                                        onClick={() => this.toggleQuestion(i)}
                                        className="persona__faq__element__question-wrapper"
                                    >
                                        <div className="persona__faq__element__question__question">
                                            {element.question}
                                        </div>
                                        <div className="persona__faq__element__question__icon">
                                            <IconDropdown className="persona__faq__element__question__icon-inner" />
                                        </div>
                                    </div>
                                    <div className="persona__faq__element__answer">
                                        {element.answer}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
